import Swal from "sweetalert2";
import {array} from "yup";

export function showError(title:string, message:string)
{
    Swal.fire({
        title: title,
        html: message,
        icon: 'warning',
        showCancelButton: false,
    })
}

export function showMultipleErrors(title:string, messages:[])
{
    const container = document.createElement('div');

    messages.forEach(message => {
        const paragraph = document.createElement('p');
        paragraph.textContent = message;
        container.appendChild(paragraph);
    });

    Swal.fire({
        title: title,
        html: container,
        icon: 'warning',
        showCancelButton: false,
    })
}

export function showSuccess(title:string, message:string)
{
    Swal.fire({
        title: title,
        html: message,
        icon: 'success',
        showCancelButton: false,
    })
}

export function showInfo(title:string, message:string)
{
    Swal.fire({
        title: title,
        html: message,
        icon: 'info',
        showCancelButton: false,
    })
}
